module.exports = __webpack_public_path__ + "static/media/delete.ab3b8bc2.svg";